import React, { useState } from "react";
import { Alert, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { OrganizationApi } from "../../../../services/Api/types";
import { selectPartner } from "../../../../services/partner/selectors";

interface Props {
	handleUpdateFormType: (t: string) => void;
	organization: OrganizationApi;
}

const SelectNewLoanMode = ({ handleUpdateFormType, organization }: Props) => {
	const [externalLoanMode, setExternalLoanMode] = useState<"POSNET" | undefined>(undefined);
	const { t } = useTranslation("admin");
	const partner = useSelector(selectPartner);

	return (
		<div className={"content-preview"}>
			{!externalLoanMode ? (
				<div className={"row"}>
					{/*<div className={"col-md-4"}>*/}
					{/*    <Card className={"card-hover"} onClick={() => handleUpdateFormType("GOPOS")}>*/}
					{/*        <Card.Body>*/}
					{/*            <h5>*/}
					{/*                Wynajmij z GoPOS*/}
					{/*            </h5>*/}
					{/*        </Card.Body>*/}
					{/*    </Card>*/}
					{/*</div>*/}
					{partner?.can_create_loans ? (
						<div className={"col-md-4"}>
							<Card className={"card-hover"} onClick={() => setExternalLoanMode("POSNET")}>
								<Card.Body>
									<h5>{t("modules.loan.field.rent_with_vero.title")}</h5>
								</Card.Body>
							</Card>
						</div>
					) : (
						<Alert variant="danger" className="w-100">
							{t("modules.loan.field.no_loan_option.title")}
						</Alert>
					)}
				</div>
			) : (
				<Card>
					<Card.Body>
						<h5>{t("modules.loan.field.rental_from_vero.title")}</h5>
						<span>
							{t("modules.loan.field.rental_from_vero.description_0")}
							<a href={"https://serwis.posnet.com/logowanie.php"} target={"_blank"} rel="noreferrer">
								{t("modules.loan.field.rental_from_vero.description_1")}
							</a>{" "}
							{t("modules.loan.field.rental_from_vero.description_2")}
						</span>
						<div className="mt-3 d-flex flex-column">
							<span>
								{t("modules.loan.field.posnet_partner_panel_address.title")}
								<a
									href={"https://serwis.posnet.com/logowanie.php"}
									target="_blank"
									className="ms-1"
									rel="noreferrer"
								>
									https://serwis.posnet.com/logowanie.php
								</a>
							</span>
							<span>
								{t("modules.loan.field.organization_id.title")}
								<strong className="ms-1">{organization.id}</strong>
							</span>
						</div>
					</Card.Body>
				</Card>
			)}
		</div>
	);
};
export default SelectNewLoanMode;
